/**
 * PositionSelectOrg 岗位选择组织弹出层 临时使用，后期应该独立成公共容器来使用
 * @author mll
 * @date 2020-01-09
 */
import React from "react";
import { connect } from "dva";
import { modelUtils } from "@/utils";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import '../../../../../../styles/containers/org/position/positionSelectOrg.less'
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizListSelect,
  WizRow,
  WizCol,
  WizButton
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

import createColumns from "./columns";

class PositionSelectOrg extends WizContainer {
  componentName = "PositionSelectOrg";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null,
      selectedRows: [],
      time: new Date().getTime(),
      recordValue: props.selectedRows
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  propsAndStateOnChange = {
    show: this._showOnChange.bind(this),
  }

  _showOnChange(nextProps, nextState) {
    if (nextProps.show && !this.props.show) {
      this._getData()
    } else if (!nextProps.show) {
      nextState.apiParams = {}
      if (this._searchBar && this._searchBar.resetFields) {
        this._searchBar.resetFields()
      }
    }
    return true
  }

  _getData(other = {}) {
    this.doAction({
      path: "organization/listByPage",
      payload: {
        key: "listByPage",
        apiParams: { ...this.state.apiParams, ...other }
      }
    });
  }

  _renderBtn = () => {
    let { updateRows, hideModal } = this.props;
    let { selectedRows, recordValue } = this.state
    return (
      <div className='position-select-org-btns'>
        <WizButton onClick={() => { hideModal() }}>取消</WizButton>
        <WizButton type="primary" onClick={() => { updateRows(Array.from(new Set([...recordValue, ...selectedRows]))); hideModal(); }}>确认</WizButton>
      </div>
    )
  }

  _onSelect = (keys, rows) => {
    let { recordValue } = this.state
    let rowkey = rows.map((r) => r.id)
    let _recordValue = recordValue.map((r) => { return rowkey.indexOf(r['id']) !== -1 ? undefined : r }).filter(Boolean)
    this.setState({
      recordValue: _recordValue,
      selectedRows: rows,
      time: new Date().getTime()
    })
  }

  _render() {
    let { orgList, organizationLoading, itemRender, time } = this.props;
    let { selectedRows, recordValue } = this.state
    const dataItems = getPageData((orgList && orgList.data) || []);
    const columns = createColumns();
    const searchBarProps = {
      columns,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };
    let records = Array.from(new Set([...selectedRows, ...recordValue]))
    const dataTableProps = {
      loading: organizationLoading,
      columns,
      rowKey: "id",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.setState({
          recordValue: Array.from(new Set([...recordValue, ...selectedRows]))
        })
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: records.map(item => item.id),
      selectedRows: records,
      onSelect: this._onSelect
    };

    const listSelectProps = {
      rows: records,
      type: '组织',
      handerClear: (id) => {
        let rows = []
        let _rows = []
        if (id || id === 0) {
          rows = selectedRows.map((i) => { return i['id'] !== id ? i : undefined }).filter(Boolean)
          _rows = recordValue.map((i) => { return i['id'] !== id ? i : undefined }).filter(Boolean)

        }
        this.setState({
          selectedRows: rows,
          recordValue: _rows
        })
        // handleClear(id)
      },
      itemRender
    }

    return [
      <WizRow>
        <WizCol span={16}>
          <WizCard bodyStyle={{ padding: '0 15px' }}>
            <WizSearchBar
              type="grid"
              ref={r => this._searchBar = r}
              {...searchBarProps}
              collapse={false}
              cols={{ xs: 14, md: 12, xl: 10 }}
            />
            <WizDataTable style={{ marginTop: 15 }} {...dataTableProps} />
          </WizCard>
        </WizCol>
        <WizCol span={8} >
          <WizListSelect key={time} {...listSelectProps} />
        </WizCol>
      </WizRow>,
      <div className="pagination">
        <WizDataTable.Pagination {...dataTableProps} size='small' />
      </div>,
      <>{this._renderBtn()}</>
    ]
  }
}

const mapStateToProps = (state, ownProps) => {
  const { organization } = state;
  const list = modelUtils.getModelEntity(organization, "listByPage");
  const load = modelUtils.getLoadingState(state, "organization");
  return {
    orgList: list,
    ...load
  };
};


export default connect(mapStateToProps)(PositionSelectOrg);
